(function () {
  function initCaseList() {
    var root = document.querySelector('[data-brv-case-list]');
    if (!root) return;

    var grid = root.querySelector('[data-brv-case-grid]');
    var filterRoot = root.querySelector('[data-brv-case-filter]');
    var countEl = root.querySelector('[data-brv-case-count]');
    var filterScroll = root.querySelector('.filter-scroll');
    var leftButton = root.querySelector('[data-brv-filter-left]');
    var rightButton = root.querySelector('[data-brv-filter-right]');
    var sortMenu = root.querySelector('[data-brv-sort-menu]');
    var sortTrigger = root.querySelector('[data-brv-sort-trigger]');
    var sortOptions = root.querySelector('[data-brv-sort-options]');
    var sortButtons = sortOptions ? Array.prototype.slice.call(sortOptions.querySelectorAll('[data-sort]')) : [];

    if (!grid || !filterRoot) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('.brv-case-list__item'));
    var activeFilter = 'すべて';
    var activeSort = 'newest';

    function updateFilterScrollControls() {
      if (!filterScroll || !leftButton || !rightButton) return;
      var maxScrollLeft = filterScroll.scrollWidth - filterScroll.clientWidth;
      leftButton.disabled = filterScroll.scrollLeft <= 4;
      rightButton.disabled = maxScrollLeft <= 4 || filterScroll.scrollLeft >= maxScrollLeft - 4;
    }

    function getVisibleItems() {
      return items.filter(function (item) {
        return !item.hidden;
      });
    }

    function updateCount() {
      if (countEl) countEl.textContent = String(getVisibleItems().length);
    }

    function compareItems(a, b) {
      if (activeSort === 'methods') {
        return Number(b.getAttribute('data-methods') || 0) - Number(a.getAttribute('data-methods') || 0);
      }
      if (activeSort === 'units') {
        return Number(b.getAttribute('data-units') || 0) - Number(a.getAttribute('data-units') || 0);
      }
      return Number(b.getAttribute('data-published') || 0) - Number(a.getAttribute('data-published') || 0);
    }

    function applySort() {
      var visible = getVisibleItems().sort(compareItems);
      var hidden = items.filter(function (item) {
        return item.hidden;
      });
      visible.concat(hidden).forEach(function (item) {
        grid.appendChild(item);
      });
    }

    function applyFilter(filter) {
      activeFilter = filter;
      items.forEach(function (item) {
        var tags = item.getAttribute('data-filters') || '';
        var show = filter === 'すべて' || tags.indexOf(filter) !== -1;
        item.hidden = !show;
      });
      applySort();
      updateCount();
    }

    filterRoot.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-filter]');
      if (!chip) return;
      filterRoot.querySelectorAll('.chip').forEach(function (el) {
        el.classList.toggle('is-active', el === chip);
      });
      applyFilter(chip.getAttribute('data-filter'));
    });

    if (sortTrigger && sortOptions) {
      sortTrigger.addEventListener('click', function () {
        var isOpen = sortTrigger.getAttribute('aria-expanded') === 'true';
        sortTrigger.setAttribute('aria-expanded', String(!isOpen));
        sortOptions.hidden = isOpen;
      });

      sortButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          activeSort = button.getAttribute('data-sort') || 'newest';
          sortButtons.forEach(function (el) {
            el.setAttribute('aria-checked', String(el === button));
          });
          sortTrigger.setAttribute('aria-expanded', 'false');
          sortOptions.hidden = true;
          applySort();
        });
      });

      document.addEventListener('click', function (event) {
        if (!event.target.closest('[data-brv-sort-menu]')) {
          sortTrigger.setAttribute('aria-expanded', 'false');
          sortOptions.hidden = true;
        }
      });
    }

    if (filterScroll && leftButton && rightButton) {
      filterScroll.addEventListener('scroll', updateFilterScrollControls);
      leftButton.addEventListener('click', function () {
        filterScroll.scrollTo({ left: filterScroll.scrollLeft - 220, behavior: 'smooth' });
      });
      rightButton.addEventListener('click', function () {
        filterScroll.scrollTo({ left: filterScroll.scrollLeft + 220, behavior: 'smooth' });
      });
      window.addEventListener('resize', updateFilterScrollControls);
      updateFilterScrollControls();
      requestAnimationFrame(updateFilterScrollControls);
    }

    applyFilter('すべて');
  }

  document.addEventListener('DOMContentLoaded', initCaseList);
})();
